(function () {
"use strict";
function cssNum(n, d) { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(n)); return v > 0.2 && v < 3 ? v : d; }
var SS = cssNum("--ff-grillz-stone-scale", 1), FILL = cssNum("--ff-stone-fill", 1), GD = cssNum("--ff-galaxy-density", 1), GB = cssNum("--ff-galaxy-big", 1);
if (!window.THREE) {
var ro = document.getElementById("readout"); ro.hidden = false; ro.textContent = "3D library failed to load. Refresh the page.";
return;
}
var SETTINGS = {
honeycomb: {
name: "Honeycomb",
blurb: "Stones set in a hexagonal lattice that locks together edge to edge. Almost no metal shows between them, so the surface reads as one solid sheet of ice.",
tiers: { 1:150, 2:275, 4:450, 6:650, 8:850, 10:1050, 12:1200, 16:1400, 20:1600 }
},
galaxy: {
name: "Galaxy",
blurb: "Stones clustered at varying sizes and depths, like a starfield. Because they sit at different heights, the sparkle moves as you move.",
tiers: { 1:150, 2:300, 4:475, 6:700, 8:900, 10:1100, 12:1300, 16:1500, 20:1700 }
},
mosaic: {
name: "Mosaic",
blurb: "A dense field of fine pavé built around one large centre stone, ringed by a hand-set halo on every tooth.",
tiers: { 1:200, 2:275, 4:475, 6:675, 8:875, 10:1050, 12:1200, 16:1600, 20:1800 }
},
baguette: {
name: "Baguette",
blurb: "Rectangular step cuts channel-set in rows across the plate, each row divided by its own rail of metal, with a fine round-stone border tracing every tooth.",
tiers: {}
}
};
(function () {
var g = SETTINGS.galaxy.tiers, k;
for (k in g) SETTINGS.baguette.tiers[k] = Math.round(g[k] * 1.15 / 5) * 5;
})();
var METALS = {
gold:  { name: "Yellow gold", sw: "#C8971F", col: 0xC9971F, rough: 0.19 },
white: { name: "White gold",  sw: "#C6D0DA", col: 0xC3CCD6, rough: 0.14 },
rose:  { name: "Rose gold",   sw: "#D18C6D", col: 0xD28E6E, rough: 0.19 }
};
function T(w, h, shape) { return { w: w, h: h, shape: shape }; }
var U_ROW = [T(7.0,7.5,"pm"), T(6.8,8.5,"pm"), T(7.6,10.0,"can"), T(6.5,9.0,"inc"),
T(8.5,10.5,"inc"), T(8.5,10.5,"inc"), T(6.5,9.0,"inc"), T(7.6,10.0,"can"),
T(6.8,8.5,"pm"), T(7.0,7.5,"pm")];
var L_ROW = [T(7.1,8.0,"pm"), T(7.0,8.5,"pm"), T(6.7,11.0,"can"), T(5.7,9.5,"inc"),
T(5.3,9.0,"inc"), T(5.3,9.0,"inc"), T(5.7,9.5,"inc"), T(6.7,11.0,"can"),
T(7.0,8.5,"pm"), T(7.1,8.0,"pm")];
function priceFor(tiers, n) {
var ks = Object.keys(tiers).map(Number).sort(function (a, b) { return a - b; });
if (!n) return 0;
if (tiers[n] != null) return tiers[n];
if (n < ks[0]) return tiers[ks[0]];
if (n > ks[ks.length - 1]) return tiers[ks[ks.length - 1]];
var lo = ks[0], hi = ks[ks.length - 1], i;
for (i = 0; i < ks.length; i++) {
if (ks[i] <= n) lo = ks[i];
if (ks[i] >= n) { hi = ks[i]; break; }
}
var t = (n - lo) / (hi - lo);
return Math.round((tiers[lo] + (tiers[hi] - tiers[lo]) * t) / 5) * 5;
}
function money(n) { return "$" + n.toLocaleString("en-US"); }
var state = { setting: "honeycomb", metal: "gold", arch: "both", n: 6, bare: false };
var VARIANTS = {
honeycomb: {1:50577629446387,2:50577629479155,3:50980007772403,4:50577629511923,5:50980007805171,6:50577629544691,7:50980007837939,8:50577629577459,9:50980007870707,10:50577629610227,11:50980007903475,12:50577629642995,13:50980007936243,14:50980007969011,15:50980008001779,16:50577629675763,17:50980008034547,18:50980008067315,19:50980008100083,20:50577629708531},
galaxy: {1:50577605132531,2:50577605165299,3:50980008132851,4:50577605198067,5:50980008165619,6:50577605230835,7:50980008198387,8:50577605263603,9:50980008231155,10:50577605296371,11:50980008263923,12:50577605329139,13:50980008296691,14:50980008329459,15:50980008362227,16:50577605361907,17:50980008394995,18:50980008427763,19:50980008460531,20:50577605394675},
mosaic: {1:50577578295539,2:50577578328307,3:50980008493299,4:50577578361075,5:50980008526067,6:50577578393843,7:50980008558835,8:50577578426611,9:50980008591603,10:50577578459379,11:50980008624371,12:50577578492147,13:50980008657139,14:50980008689907,15:50980008722675,16:50577578524915,17:50980008755443,18:50980008788211,19:50980008820979,20:50577578557683},
baguette: {1:50980013834483,2:50980013867251,3:50980013900019,4:50980013932787,5:50980013965555,6:50980013998323,7:50980014031091,8:50980014063859,9:50980014096627,10:50980014129395,11:50980014162163,12:50980014194931,13:50980014227699,14:50980014260467,15:50980014293235,16:50980014326003,17:50980014358771,18:50980014391539,19:50980014424307,20:50980014457075}
};
var UPPER_N = [4,5,6,7,8,9,10,11,12,13], LOWER_N = [29,28,27,26,25,24,23,22,21,20];
var SHOP_BASE = (typeof location !== "undefined" && /(^|\.)flexfactoryice\.com$|\.myshopify\.com$/i.test(location.hostname || "")) ? "" : "https://flexfactoryice.com";
var TERMS_VERSION = "2026-09-20";
var TERMS = [
"Payment is taken by Shopify’s secure checkout on the next screen. Flex Factory never sees or stores your card details.",
"The price covers your impression kit, the prepaid return mailer, fabrication and shipping back to you inside the US.",
"Build time is 6 to 8 weeks from the day your impression reaches us, not from the day you order.",
"You see photographs of the finished set before it leaves the bench. If something is off, it goes back.",
"If the fit is wrong on arrival we re-cut it at no charge. If your impression comes out unusable we send a fresh kit at no charge.",
"Every set is cut to your own impression and is made for you alone. It is a final sale: it cannot be returned, exchanged or refunded for a change of mind. What stays covered is our own work: if the fit is wrong or the set is faulty, we re-cut or repair it at no charge."
];
function archNums(row, n) {
var first = Math.floor((10 - n) / 2), a = row.slice(first, first + n);
var lo = Math.min.apply(null, a), hi = Math.max.apply(null, a);
return "#" + lo + "–#" + hi;
}
function positionsText() {
var p = [];
if (state.arch !== "lower") p.push("Upper " + archNums(UPPER_N, state.n));
if (state.arch !== "upper") p.push("Lower " + archNums(LOWER_N, state.n));
return p.join("; ");
}
function archSummary() {
if (state.arch === "both") return state.n + " upper / " + state.n + " lower";
return state.n + (state.arch === "upper" ? " upper" : " lower");
}
function checkoutURL() {
var S = SETTINGS[state.setting], n = teethTotal();
var v = VARIANTS[state.setting] && VARIANTS[state.setting][n];
if (!v) return "";
var a = [];
function add(k, val) { if (val) a.push("attributes[" + encodeURIComponent(k) + "]=" + encodeURIComponent(val)); }
add("Setting", S.name + " Setting");
add("Finish", METALS[state.metal].name);
add("Teeth", n + " (" + archSummary() + ")");
add("Tooth positions", positionsText());
add("Build time", "6-8 weeks from the day the impression arrives");
add("Terms", "Accepted in the 3D studio - v" + TERMS_VERSION);
add("Built with", "3D studio");
return SHOP_BASE + "/cart/" + v + ":1?" + a.join("&");
}
var EXP = { inc: 5.6, can: 4.2, pm: 5.0 };
var POINTED = false;
function centroidY(tt) {
var n = 60, a = 0, m = 0, i;
for (i = 0; i < n; i++) { var v = (i + 0.5) / n, hw = halfW(tt.w, tt.h, tt.shape, v); a += hw; m += hw * (v - 0.5) * tt.h; }
return a ? m / a : 0;
}
var BEZEL = 0.055;
var CROWN = {
inc: { nI: 4.6, nC: 3.0, c: 0.93, vp: 0.22, k: 0.24 },
can: { nI: 1.85, nC: 3.0, c: 0.93, vp: 0.36, k: 0.26 },
pm:  { nI: 2.5, nC: 3.0, c: 0.93, vp: 0.40, k: 0.18 }
};
function halfW(w, h, shape, v) {
var s = CROWN[shape] || CROWN.inc;
var n = v < 0.5 ? s.nI : s.nC, ty = Math.min(1, Math.abs(v * 2 - 1)) * (v < 0.5 ? 1 : s.c);
var end = Math.pow(Math.max(0, 1 - Math.pow(ty, n)), 1 / n);
var t = v > s.vp ? Math.pow((v - s.vp) / (1 - s.vp), 1.5) : 0;
var hw = (w / 2) * end * (1 - s.k * t);
if (POINTED) {
if (v < 0.5) hw = (w / 2) * Math.pow(Math.max(0, 1 - Math.pow(ty, 4.5)), 1 / 4.5);
else if (v > 0.52) hw = (w / 2) * Math.pow(Math.max(0, (1 - v) / 0.48), 0.82);
else hw = w / 2;
}
return hw;
}
function bulge(u, v) {
var a = Math.pow(Math.max(0, 1 - u * u), 0.60);
var b = Math.pow(Math.max(0, 1 - Math.pow(Math.abs(v * 2 - 1), 2.6)), 0.42);
return a * b;
}
function surfacePoint(tt, u, v, out) {
var hw = halfW(tt.w, tt.h, tt.shape, v);
out.set(u * hw, (v - 0.5) * tt.h, bulge(u, v) * tt.d);
return out;
}
var _pa = new THREE.Vector3(), _pb = new THREE.Vector3(), _pc = new THREE.Vector3(),
_du = new THREE.Vector3(), _dv = new THREE.Vector3();
function surfaceNormal(tt, u, v, out) {
var e = 0.012;
surfacePoint(tt, Math.min(1, u + e), v, _pa);
surfacePoint(tt, Math.max(-1, u - e), v, _pb);
_du.subVectors(_pa, _pb);
surfacePoint(tt, u, Math.min(1, v + e), _pa);
surfacePoint(tt, u, Math.max(0, v - e), _pc);
_dv.subVectors(_pa, _pc);
out.crossVectors(_du, _dv).normalize();
if (out.z < 0) out.negate();
return out;
}
function shellGeometry(tt, back) {
var NU = 30, NV = 34, i, j, u, v;
var pos = [], idx = [];
var p = new THREE.Vector3();
function push(layer) {
for (j = 0; j <= NV; j++) {
v = j / NV;
for (i = 0; i <= NU; i++) {
u = (i / NU) * 2 - 1;
surfacePoint(tt, u, v, p);
if (layer) back(p, pos);
else pos.push(p.x, p.y, p.z);
}
}
}
push(0); push(1);
var ring = (NU + 1) * (NV + 1);
function quad(a, b, c, d) { idx.push(a, b, c, a, c, d); }
for (j = 0; j < NV; j++) {
for (i = 0; i < NU; i++) {
var a = j * (NU + 1) + i, b = a + 1, c = a + NU + 2, d = a + NU + 1;
quad(a, b, c, d);
quad(ring + a, ring + d, ring + c, ring + b);
}
}
for (j = 0; j < NV; j++) {
var l0 = j * (NU + 1), l1 = (j + 1) * (NU + 1);
quad(l0, l1, ring + l1, ring + l0);
var r0 = l0 + NU, r1 = l1 + NU;
quad(r1, r0, ring + r0, ring + r1);
}
for (i = 0; i < NU; i++) {
var t0 = NV * (NU + 1) + i, t1 = t0 + 1;
quad(t0, t1, ring + t1, ring + t0);
var b0 = i, b1 = i + 1;
quad(b1, b0, ring + b0, ring + b1);
}
var g = new THREE.BufferGeometry();
g.setAttribute("position", new THREE.Float32BufferAttribute(pos, 3));
g.setIndex(idx);
g.computeVertexNormals();
return g;
}
function capGeometry(tt) {
return shellGeometry(tt, function (p, pos) { pos.push(p.x, p.y, -p.z * 0.98 - 0.35 - 0.55); });
}
function toothGeometry(tt) {
return shellGeometry(tt, function (p, pos) { pos.push(p.x, p.y, -p.z * 0.95 - 0.35); });
}
function seeded(s) {
return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; };
}
function insideFoot(tt, x, y, margin) {
var v = y / tt.h + 0.5;
if (v <= 0.015 || v >= 0.985) return 0;
var hw = halfW(tt.w, tt.h, tt.shape, v);
return hw > margin + 0.05 && Math.abs(x) <= hw - margin;
}
function fieldHoneycomb(tt) {
var r = tt.w * 0.044 * SS, out = [];
var dx = r * 1.97, dy = dx * 0.866, row = 0, y, x;
for (y = -tt.h / 2 + r * 0.95; y <= tt.h / 2; y += dy, row++) {
var off = (row % 2) ? dx / 2 : 0;
for (x = -tt.w / 2 + off; x <= tt.w / 2; x += dx) {
if (insideFoot(tt, x, y, r * 0.42)) out.push({ x: x, y: y, r: r, kind: 0, sink: 0, spin: 0 });
}
}
return out;
}
function fieldGalaxy(tt) {
var rnd = seeded(Math.round(tt.w * 977 + tt.h * 131 + (tt.idx || 0) * 7919)), out = [], i, k;
var base = tt.w * 0.026 * SS / GD;
var nBig = 1 + Math.floor(rnd() * 3);
var bigR = (nBig === 1 ? 0.205 : nBig === 2 ? 0.165 : 0.135) * GB;
for (i = 0; i < nBig; i++) {
for (k = 0; k < 80; k++) {
var R = tt.w * bigR * (0.88 + rnd() * 0.24);
var bx = (rnd() - 0.5) * tt.w * 0.7, by = (rnd() - 0.5) * tt.h * 0.75;
var clear = insideFoot(tt, bx, by, R * 1.08);
for (var q = 0; q < 12 && clear; q++) { var aq = q * 0.5236; clear = insideFoot(tt, bx + Math.cos(aq) * R * 1.1, by + Math.sin(aq) * R * 1.1, 0.05); }
if (!clear) { if (k > 60) R *= 0.97; continue; }
for (var j = 0; j < out.length; j++) {
var dx0 = bx - out[j].x, dy0 = by - out[j].y, lim0 = (R + out[j].r) * 1.08;
if (dx0 * dx0 + dy0 * dy0 < lim0 * lim0) { clear = false; break; }
}
if (clear) { out.push({ x: bx, y: by, r: R, kind: 0, sink: 0, ch: 0.5, spin: rnd() * 6.283 }); break; }
}
}
var bigs = out.slice();
var cell = base * 3.2, grid = {};
function key(cx, cy) { return cx + "," + cy; }
function fits(x, y, r) {
var b, m, dx, dy, lim;
for (m = 0; m < bigs.length; m++) {
b = bigs[m]; dx = x - b.x; dy = y - b.y; lim = (r + b.r) * 0.95;
if (dx * dx + dy * dy < lim * lim) return false;
}
var cx = Math.floor(x / cell), cy = Math.floor(y / cell), gx, gy, list, n;
for (gx = cx - 1; gx <= cx + 1; gx++) for (gy = cy - 1; gy <= cy + 1; gy++) {
list = grid[key(gx, gy)]; if (!list) continue;
for (n = 0; n < list.length; n++) {
dx = x - list[n].x; dy = y - list[n].y; lim = (r + list[n].r) * 0.93;
if (dx * dx + dy * dy < lim * lim) return false;
}
}
return true;
}
function add(st) { var g = key(Math.floor(st.x / cell), Math.floor(st.y / cell)); (grid[g] || (grid[g] = [])).push(st); out.push(st); }
[1.45, 1.1, 0.85, 0.66, 0.52].forEach(function (f, pass) {
var r0 = base * f, dx = r0 * 1.95, dy = dx * 0.866, ox = rnd() * dx, oy = rnd() * dy, row = 0, x, y;
for (y = -tt.h / 2 + oy; y <= tt.h / 2; y += dy, row++) {
for (x = -tt.w / 2 + ox + ((row % 2) ? dx / 2 : 0); x <= tt.w / 2; x += dx) {
var r = r0 * (0.9 + rnd() * 0.2);
var jx = x + (rnd() - 0.5) * dx * 0.3, jy = y + (rnd() - 0.5) * dy * 0.3;
if (pass < 2 && rnd() < 0.35) continue;
if (!insideFoot(tt, jx, jy, r * 0.5)) continue;
if (fits(jx, jy, r)) add({ x: jx, y: jy, r: r, kind: 0, sink: (rnd() * 0.4) * r * 0.3, spin: rnd() * 6.283 });
}
}
});
return out;
}
function fieldMosaic(tt) {
var out = [], i;
var R = tt.w * 0.225, cy = tt.h * 0.04;
out.push({ x: 0, y: cy, r: R, kind: 0, sink: R * 0.10, spin: 0 });
var hr = tt.w * 0.034 * SS, ring = R + hr * 1.08, nH = Math.round((6.283 * ring) / (hr * 2.15));
for (i = 0; i < nH; i++) {
var a = (i / nH) * 6.283;
var hx = Math.cos(a) * ring, hy = cy + Math.sin(a) * ring;
if (insideFoot(tt, hx, hy, hr * 0.8)) out.push({ x: hx, y: hy, r: hr, kind: 0, sink: 0, spin: 0 });
}
var guard = ring + hr * 1.0;
var pr = tt.w * 0.026 * SS, dx = pr * 2.02, dy = dx * 0.866, row = 0, y, x;
for (y = -tt.h / 2 + dy * 0.6; y <= tt.h / 2; y += dy, row++) {
var off = (row % 2) ? dx / 2 : 0;
for (x = -tt.w / 2 + off; x <= tt.w / 2; x += dx) {
var d = Math.sqrt(x * x + (y - cy) * (y - cy));
if (d < guard + pr * 0.8) continue;
if (insideFoot(tt, x, y, pr * 0.45)) out.push({ x: x, y: y, r: pr, kind: 0, sink: 0, spin: 0 });
}
}
fillGaps(tt, out, pr * 0.72, pr * 0.55);
return out;
}
function fieldBaguette(tt) {
var out = [], i, j, ring;
var w = tt.w, h = tt.h;
var br = w * 0.022 * SS;
var steps = Math.round(h / (br * 2.15));
for (i = 0; i < steps; i++) {
var v = (i + 0.5) / steps, hw = halfW(w, h, tt.shape, v);
if (hw < br * 2.0) continue;
var yy = (v - 0.5) * h;
out.push({ x: hw - br * 1.15, y: yy, r: br, kind: 0, sink: 0, spin: 0 });
out.push({ x: -(hw - br * 1.15), y: yy, r: br, kind: 0, sink: 0, spin: 0 });
}
var hw0 = halfW(w, h, tt.shape, 0.045);
for (var bx = -hw0 + br * 2.4; bx <= hw0 - br * 2.4; bx += br * 2.3)
out.push({ x: bx, y: -h / 2 + br * 1.3, r: br, kind: 0, sink: 0, spin: 0 });
var cx = 0, cy = centroidY(tt);
var CW = w * 0.19, CH = h * 0.30;
var bez = BEZEL * w;
var L = w * 0.105, S = w * 0.050, g = w * 0.009;
out.push({ x: cx, y: cy, r: CW / 2, h2: CH / 2, kind: 1, sink: 0.30, spin: 0 });
var keepOut = br * 2.1;
function fits(x, y, hx, hy) {
return insideFoot(tt, x - hx, y - hy, keepOut) && insideFoot(tt, x + hx, y - hy, keepOut) &&
insideFoot(tt, x - hx, y + hy, keepOut) && insideFoot(tt, x + hx, y + hy, keepOut);
}
for (ring = 0; ring < 7; ring++) {
var innerW = CW / 2 + bez + ring * (L + g), innerH = CH / 2 + bez + ring * (L + g);
var placed = 0;
var colX = innerW + g + L / 2;
var spanY = innerH + L / 2;
var n = Math.max(1, Math.floor((spanY * 2 + g) / (S + g)));
for (i = 0; i < n; i++) {
var y1 = cy - ((n - 1) * (S + g)) / 2 + i * (S + g);
[-colX, colX].forEach(function (x1) {
if (fits(cx + x1, y1, L / 2, S / 2)) { out.push({ x: cx + x1, y: y1, r: L / 2, h2: S / 2, kind: 1, sink: 0, spin: 0 }); placed++; }
});
}
var rowY = innerH + g + L / 2;
var spanX = innerW;
var m = Math.max(1, Math.floor((spanX * 2 + g) / (S + g)));
for (j = 0; j < m; j++) {
var x2 = cx - ((m - 1) * (S + g)) / 2 + j * (S + g);
[-rowY, rowY].forEach(function (yq) {
if (fits(x2, cy + yq, S / 2, L / 2)) { out.push({ x: x2, y: cy + yq, r: S / 2, h2: L / 2, kind: 1, sink: 0, spin: 0 }); placed++; }
});
}
if (!placed) break;
}
fillTiles(tt, out, cx, cy, S / 2, g, keepOut);
return out;
}
function fillGaps(tt, out, r, margin) {
var dx = r * 2.08, dy = dx * 0.866, row = 0, y, x, i, added = [];
for (y = -tt.h / 2 + r; y <= tt.h / 2; y += dy, row++) {
var off = (row % 2) ? dx / 2 : 0;
for (x = -tt.w / 2 + off; x <= tt.w / 2; x += dx) {
if (!insideFoot(tt, x, y, margin)) continue;
var clear = true;
for (i = 0; i < out.length; i++) {
var o = out[i], d;
if (o.kind === 1) {
var ex = Math.max(Math.abs(x - o.x) - o.r, 0), ey = Math.max(Math.abs(y - o.y) - o.h2, 0);
d = Math.sqrt(ex * ex + ey * ey);
if (d < r * 0.98) { clear = false; break; }
} else {
var ddx = x - o.x, ddy = y - o.y;
d = Math.sqrt(ddx * ddx + ddy * ddy);
if (d < (r + o.r) * 0.96) { clear = false; break; }
}
}
if (clear) added.push({ x: x, y: y, r: r, kind: 0, sink: 0, spin: 0 });
}
}
for (i = 0; i < added.length; i++) out.push(added[i]);
}
function fillTiles(tt, out, cx, cy, half, g, keepOut) {
var pitch = half * 2 + g, i, j, k, added = [];
var nx = Math.ceil(tt.w / pitch) + 1, ny = Math.ceil(tt.h / pitch) + 1;
for (j = -ny; j <= ny; j++) {
for (i = -nx; i <= nx; i++) {
var x = cx + i * pitch, y = cy + j * pitch;
if (!(insideFoot(tt, x - half, y - half, keepOut) && insideFoot(tt, x + half, y - half, keepOut) &&
insideFoot(tt, x - half, y + half, keepOut) && insideFoot(tt, x + half, y + half, keepOut))) continue;
var clear = true;
for (k = 0; k < out.length; k++) {
var o = out[k];
if (o.kind === 1) {
if (Math.abs(x - o.x) < half + o.r - g * 0.5 && Math.abs(y - o.y) < half + o.h2 - g * 0.5) { clear = false; break; }
} else {
var ex = Math.max(Math.abs(o.x - x) - half, 0), ey = Math.max(Math.abs(o.y - y) - half, 0);
if (ex * ex + ey * ey < o.r * o.r * 0.9) { clear = false; break; }
}
}
if (clear) added.push({ x: x, y: y, r: half, h2: half, kind: 1, sink: 0, spin: 0 });
}
}
for (k = 0; k < added.length; k++) out.push(added[k]);
}
var FIELDS = { honeycomb: fieldHoneycomb, galaxy: fieldGalaxy, mosaic: fieldMosaic, baguette: fieldBaguette };
var cvs = document.getElementById("gl");
var renderer, scene, camera, root, env, keyLight, rimLight;
var metalMat, stoneMat, moldMat, toothMat;
var cam = { az: 0, el: 0.30, dist: 150, tAz: 0, tEl: 0.30, tDist: 110 };
var spin = true, dragging = false, lastX = 0, lastY = 0, userZoomed = false, swayT = 0;
var clock = { t: 0, last: 0, w: 0 };
var anim = {
stones: [],
setStart: 0,
setDur: 1.35,
settling: false,
flashes: [],
metalTo: null,
introDone: false
};
function studioEnv(r) {
var c = document.createElement("canvas");
c.width = 1024; c.height = 512;
var x = c.getContext("2d");
var g = x.createLinearGradient(0, 0, 0, 512);
g.addColorStop(0, "#0C1119"); g.addColorStop(0.46, "#070910");
g.addColorStop(0.52, "#0B0E16"); g.addColorStop(1, "#020306");
x.fillStyle = g; x.fillRect(0, 0, 1024, 512);
[[150, 86, 74, 1.0], [620, 70, 56, 0.85], [400, 150, 30, 0.45], [880, 120, 40, 0.5]].forEach(function (s) {
var rg = x.createRadialGradient(s[0] + s[2] / 2, s[1] + s[3] / 2, 2,
s[0] + s[2] / 2, s[1] + s[3] / 2, s[2]);
rg.addColorStop(0, "rgba(255,255,255," + s[3] + ")");
rg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = rg; x.fillRect(s[0] - s[2], s[1] - s[2], s[2] * 3, s[2] * 3);
});
x.fillStyle = "rgba(120,160,255,.10)"; x.fillRect(0, 300, 1024, 212);
[[0, 200, 1024, 110, 0.22], [230, 230, 60, 60, 0.6], [790, 230, 60, 60, 0.6]].forEach(function (b) {
var lg = x.createLinearGradient(0, b[1], 0, b[1] + b[3]);
lg.addColorStop(0, "rgba(255,250,240,0)"); lg.addColorStop(0.5, "rgba(255,250,240," + b[4] + ")"); lg.addColorStop(1, "rgba(255,250,240,0)");
x.fillStyle = lg; x.fillRect(b[0], b[1], b[2], b[3]);
});
var seed = 7, k;
function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
for (k = 0; k < 70; k++) {
var sx = rnd() * 1024, sy = 20 + rnd() * 250, sr = 2.5 + rnd() * 5, sa = 0.55 + rnd() * 0.45;
var pg = x.createRadialGradient(sx, sy, 0, sx, sy, sr);
pg.addColorStop(0, "rgba(255,255,255," + sa + ")"); pg.addColorStop(0.45, "rgba(255,255,255," + (sa * 0.5) + ")"); pg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = pg; x.fillRect(sx - sr, sy - sr, sr * 2, sr * 2);
}
var tex = new THREE.CanvasTexture(c);
tex.mapping = THREE.EquirectangularReflectionMapping;
var p = new THREE.PMREMGenerator(r);
p.compileEquirectangularShader();
var t = p.fromEquirectangular(tex).texture;
p.dispose(); tex.dispose();
return t;
}
function init() {
renderer = new THREE.WebGLRenderer({ canvas: cvs, antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.05;
scene = new THREE.Scene();
camera = new THREE.PerspectiveCamera(30, 1, 1, 900);
env = studioEnv(renderer);
scene.environment = env;
scene.add(new THREE.AmbientLight(0xffffff, 0.12));
keyLight = new THREE.DirectionalLight(0xffffff, 1.9);
keyLight.position.set(26, 42, 58); scene.add(keyLight);
rimLight = new THREE.DirectionalLight(0xBFD4FF, 0.8);
rimLight.position.set(-44, 14, -36); scene.add(rimLight);
var fill = new THREE.DirectionalLight(0xFFE7BF, 0.4);
fill.position.set(-20, -34, 30); scene.add(fill);
var M = METALS[state.metal];
metalMat = new THREE.MeshStandardMaterial({
color: M.col, metalness: 1.0, roughness: M.rough, envMapIntensity: 1.5
});
stoneMat = new THREE.MeshPhysicalMaterial({
color: 0xF4F8FF, metalness: 0.72, roughness: 0.025,
clearcoat: 1.0, clearcoatRoughness: 0.02,
envMapIntensity: 2.2, reflectivity: 1.0, flatShading: true
});
moldMat = new THREE.MeshStandardMaterial({
color: 0xF1EDE4, metalness: 0.0, roughness: 0.92, envMapIntensity: 0.35
});
toothMat = new THREE.MeshStandardMaterial({
color: 0xF6F3EC, metalness: 0.0, roughness: 0.78, envMapIntensity: 0.4
});
root = new THREE.Group();
scene.add(root);
resize();
window.addEventListener("resize", resize);
}
var sizeW = -1, sizeH = -1;
function resize() {
var w = cvs.clientWidth, h = cvs.clientHeight;
if (!w || !h) return false;
if (w === sizeW && h === sizeH) return true;
sizeW = w; sizeH = h;
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.setSize(w, h, false);
camera.aspect = w / h;
camera.updateProjectionMatrix();
if (!userZoomed) frameCamera();
return true;
}
function clearRoot() {
for (var i = root.children.length - 1; i >= 0; i--) {
var o = root.children[i];
o.traverse(function (c) {
if (c.geometry) c.geometry.dispose();
});
root.remove(o);
}
anim.stones = [];
anim.flashes = [];
root.position.set(0, 0, 0);
root.rotation.set(0, 0, 0);
root.updateMatrixWorld(true);
}
function archMapper(A, B, tMax) {
var N = 240, ts = [], ls = [], L = 0, i;
var px = 0, pz = B, x, z;
ts.push(0); ls.push(0);
for (i = 1; i <= N; i++) {
var t = (i / N) * tMax;
x = A * Math.sin(t); z = B * Math.cos(t);
L += Math.sqrt((x - px) * (x - px) + (z - pz) * (z - pz));
px = x; pz = z; ts.push(t); ls.push(L);
}
return function (s) {
var sign = s < 0 ? -1 : 1, a = Math.min(Math.abs(s), L), j;
for (j = 1; j < ls.length; j++) if (ls[j] >= a) break;
if (j >= ls.length) j = ls.length - 1;
var f = (a - ls[j - 1]) / Math.max(1e-6, ls[j] - ls[j - 1]);
return sign * (ts[j - 1] + (ts[j] - ts[j - 1]) * f);
};
}
function gumBlock(A, B, which, yTop, depth) {
var sh = new THREE.Shape(), t, n = 40, i;
var tMax = 1.62, oA = A - 0.6, oB = B - 0.6, iA = A - 8.4, iB = B - 7.6;
for (i = 0; i <= n; i++) { t = -tMax + (2 * tMax * i) / n; var x = oA * Math.sin(t), z = oB * Math.cos(t); i ? sh.lineTo(x, z) : sh.moveTo(x, z); }
for (i = n; i >= 0; i--) { t = -tMax + (2 * tMax * i) / n; sh.lineTo(iA * Math.sin(t), iB * Math.cos(t)); }
sh.closePath();
var geo = new THREE.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: true, bevelThickness: 0.9, bevelSize: 0.9, bevelSegments: 3, steps: 1 });
var m = new THREE.Mesh(geo, moldMat);
m.rotation.x = Math.PI / 2;
m.position.y = yTop;
return m;
}
function buildArch(rowDims, which, count) {
var g = new THREE.Group();
var first = Math.floor((10 - count) / 2);
var A = which === "upper" ? 24.8 : 21.8;
var B = which === "upper" ? 19.6 : 17.2;
var toT = archMapper(A, B, 1.32);
var total = 0, i;
for (i = 0; i < rowDims.length; i++) total += rowDims[i].w * 0.90;
var depth = { inc: 2.55, can: 2.75, pm: 2.3 };
var run = -total / 2, out = [];
for (i = 0; i < rowDims.length; i++) {
var d0 = rowDims[i];
var tt = { w: d0.w, h: d0.h, shape: d0.shape, d: depth[d0.shape] || 2.5, idx: i + (which === "upper" ? 0 : 20) };
var centre = run + d0.w * 0.90 / 2;
run += d0.w * 0.90;
var t = toT(centre);
var px = A * Math.sin(t), pz = B * Math.cos(t);
var nx = Math.sin(t) / A, nz = Math.cos(t) / B;
var nl = Math.sqrt(nx * nx + nz * nz); nx /= nl; nz /= nl;
var node = new THREE.Group();
node.position.set(px, 0, pz);
node.rotation.y = Math.atan2(nx, nz);
if (which === "upper") {
node.position.y = tt.h / 2 + 0.55;
node.rotation.x = -0.10;
} else {
node.position.y = -tt.h / 2 - 0.55;
node.rotation.x = 0.07;
node.rotation.z = Math.PI;
}
node.updateMatrix();
node.userData.tt = tt;
node.userData.capped = i >= first && i < first + count;
g.add(node);
out.push(node);
}
var gumFrom = 0.55 + 5.6, gumDepth = 4.8;
if (which === "upper") g.add(gumBlock(A, B, which, gumFrom + gumDepth, gumDepth));
else g.add(gumBlock(A, B, which, -gumFrom, gumDepth));
g.userData.teeth = out;
return g;
}
var fitSpan = null;
function frameCamera() {
if (!fitSpan) return;
var half = Math.tan((camera.fov / 2) * Math.PI / 180);
var byH = (fitSpan.y * 1.9 + 10) / (2 * half);
var byW = (fitSpan.x * 1.12 + 8) / (2 * half * Math.max(0.5, camera.aspect));
cam.tDist = Math.max(36, Math.max(byH, byW) * 1.18);
}
var _n = new THREE.Vector3(), _p = new THREE.Vector3(),
_q = new THREE.Quaternion(), _up = new THREE.Vector3(0, 1, 0),
_m = new THREE.Matrix4(), _sc = new THREE.Vector3(),
_tw = new THREE.Quaternion(), _wp = new THREE.Vector3(),
_wq = new THREE.Quaternion(), _ws = new THREE.Vector3(),
_white = new THREE.Color(1, 1, 1), _flash = new THREE.Color(),
_tx = new THREE.Vector3(), _ty = new THREE.Vector3(), _bm = new THREE.Matrix4();
function makeInstanced(geo, list) {
var mesh = new THREE.InstancedMesh(geo, stoneMat, list.length);
var rec = { mesh: mesh, pos: [], quat: [], scl: [], delay: [] };
var minX = Infinity, maxX = -Infinity, i;
for (i = 0; i < list.length; i++) {
list[i].decompose(_wp, _wq, _ws);
rec.pos.push(_wp.clone()); rec.quat.push(_wq.clone()); rec.scl.push(_ws.clone());
if (_wp.x < minX) minX = _wp.x;
if (_wp.x > maxX) maxX = _wp.x;
mesh.setColorAt(i, _white);
}
var span = Math.max(1, maxX - minX);
for (i = 0; i < list.length; i++) {
rec.delay.push(((rec.pos[i].x - minX) / span) * 0.78 + Math.random() * 0.17);
_m.compose(rec.pos[i], rec.quat[i], _sc.set(0.0001, 0.0001, 0.0001));
mesh.setMatrixAt(i, _m);
}
mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
if (mesh.instanceColor) {
mesh.instanceColor.setUsage(THREE.DynamicDrawUsage);
mesh.instanceColor.needsUpdate = true;
}
mesh.instanceMatrix.needsUpdate = true;
return rec;
}
function bezelMesh(tt) {
var w = tt.w, h = tt.h, CW = w * 0.19, CH = h * 0.30, bez = BEZEL * w;
var sh = new THREE.Shape();
sh.moveTo(-CW / 2 - bez, -CH / 2 - bez); sh.lineTo(CW / 2 + bez, -CH / 2 - bez);
sh.lineTo(CW / 2 + bez, CH / 2 + bez); sh.lineTo(-CW / 2 - bez, CH / 2 + bez); sh.closePath();
var hole = new THREE.Path();
hole.moveTo(-CW / 2, -CH / 2); hole.lineTo(-CW / 2, CH / 2); hole.lineTo(CW / 2, CH / 2); hole.lineTo(CW / 2, -CH / 2); hole.closePath();
sh.holes.push(hole);
var geo = new THREE.ExtrudeGeometry(sh, { depth: 0.55, bevelEnabled: true, bevelThickness: 0.08, bevelSize: 0.06, bevelSegments: 2, steps: 1 });
var m = new THREE.Mesh(geo, metalMat);
var cy = centroidY(tt), v = cy / h + 0.5;
surfacePoint(tt, 0, v, _p); surfaceNormal(tt, 0, v, _n);
m.position.set(_p.x * 1.035, _p.y * 1.03, _p.z + 0.22);
m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), _n);
return m;
}
function build() {
clearRoot();
POINTED = false;
var arches = [];
if (state.arch === "both" || state.arch === "upper") arches.push(["upper", U_ROW]);
if (state.arch === "both" || state.arch === "lower") arches.push(["lower", L_ROW]);
var field = FIELDS[state.setting];
var rounds = [], bags = [];
var stoneCt = 0;
arches.forEach(function (a) {
var grp = buildArch(a[1], a[0], state.n);
root.add(grp);
grp.userData.teeth.forEach(function (node) {
var tt = node.userData.tt;
node.add(new THREE.Mesh(toothGeometry(tt), toothMat));
if (!node.userData.capped) return;
var cap = new THREE.Mesh(capGeometry(tt), metalMat);
cap.scale.set(1.035, 1.03, 1);
cap.position.z = 0.22;
cap.userData.isCap = true;
node.add(cap);
if (state.setting === "baguette") node.add(bezelMesh(tt));
if (state.bare) return;
var local = node.matrix;
var spots = field(tt);
stoneCt += spots.length;
spots.forEach(function (s) {
var v = s.y / tt.h + 0.5;
var hw = halfW(tt.w, tt.h, tt.shape, v);
if (hw < 1e-4) return;
var u = Math.max(-1, Math.min(1, s.x / hw));
surfacePoint(tt, u, v, _p);
surfaceNormal(tt, u, v, _n);
var crown = s.r * (s.ch || 0.80);
var lift = crown * 0.48 - Math.min(0.03, crown * 0.1) + (s.sink || 0);
_p.x *= 1.035; _p.y *= 1.03; _p.z += 0.22;
_p.addScaledVector(_n, lift);
_ty.set(0, 1, 0).addScaledVector(_n, -_n.y).normalize();
_tx.crossVectors(_n, _ty).normalize();
_bm.makeBasis(_tx, _n, _ty);
_q.setFromRotationMatrix(_bm);
if (s.spin) { _tw.setFromAxisAngle(_n, s.spin); _q.premultiply(_tw); }
if (s.kind === 1) {
_sc.set(s.r, crown * 1.1, (s.h2 || s.r));
_m.compose(_p, _q, _sc);
bags.push(new THREE.Matrix4().multiplyMatrices(local, _m));
} else {
_sc.set(s.r * FILL, crown, s.r * FILL);
_m.compose(_p, _q, _sc);
rounds.push(new THREE.Matrix4().multiplyMatrices(local, _m));
}
});
});
});
if (rounds.length) {
var rg = new THREE.CylinderGeometry(0.46, 1.0, 1.0, 16, 1, false);
var r1 = makeInstanced(rg, rounds);
root.add(r1.mesh); anim.stones.push(r1);
}
if (bags.length) {
var bg = new THREE.CylinderGeometry(0.80, 1.0, 1.0, 4, 1, false);
bg.rotateY(Math.PI / 4);
bg.scale(Math.SQRT2, 1, Math.SQRT2);
var b1 = makeInstanced(bg, bags);
root.add(b1.mesh); anim.stones.push(b1);
}
root.updateMatrixWorld(true);
var box = new THREE.Box3();
root.traverse(function (o) {
if (o.isMesh && o.userData.isCap) box.expandByObject(o);
});
if (box.isEmpty()) root.traverse(function (o) { if (o.isMesh && !o.isInstancedMesh) box.expandByObject(o); });
var c = box.getCenter(new THREE.Vector3());
root.position.set(-c.x, -c.y, -c.z);
var span = box.getSize(new THREE.Vector3());
fitSpan = span;
frameCamera();
anim.setStart = clock.w;
anim.settling = !state.bare;
paintReadout(stoneCt);
}
function easeBack(t) {
var c1 = 1.70158, c3 = c1 + 1;
return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}
function stepSetting() {
if (!anim.settling) return;
var el = clock.w - anim.setStart, done = true, k;
anim.stones.forEach(function (rec) {
var n = rec.pos.length, i;
for (i = 0; i < n; i++) {
var t = (el - rec.delay[i] * anim.setDur) / 0.38;
if (t < 0) { done = false; continue; }
if (t >= 1) k = 1; else { k = easeBack(t); done = false; }
_sc.copy(rec.scl[i]).multiplyScalar(Math.max(0.0001, k));
_wp.copy(rec.pos[i]);
if (t < 1) { _n.set(0, 1, 0).applyQuaternion(rec.quat[i]); _wp.addScaledVector(_n, (1 - t) * 1.6); }
_m.compose(_wp, rec.quat[i], _sc);
rec.mesh.setMatrixAt(i, _m);
}
rec.mesh.instanceMatrix.needsUpdate = true;
});
if (done) anim.settling = false;
}
var TINTS = [[1, 1, 1], [1, 1, 1], [0.6, 0.78, 1], [1, 0.62, 0.62], [1, 0.9, 0.5], [0.62, 1, 0.72], [0.9, 0.62, 1]];
function stepFire(dt) {
if (!anim.stones.length || anim.settling) return;
var total = 0;
anim.stones.forEach(function (r) { total += r.pos.length; });
var want = total / 22, i;
var spawn = (want / 0.55) * dt;
while (spawn > 0) {
if (Math.random() < spawn) {
var rec = anim.stones[Math.floor(Math.random() * anim.stones.length)];
anim.flashes.push({
rec: rec, i: Math.floor(Math.random() * rec.pos.length),
t0: clock.w, dur: 0.35 + Math.random() * 0.5,
tint: TINTS[Math.floor(Math.random() * TINTS.length)],
amp: 2.5 + Math.random() * 4.5
});
}
spawn -= 1;
}
var touched = new Set();
for (i = anim.flashes.length - 1; i >= 0; i--) {
var f = anim.flashes[i], life = (clock.w - f.t0) / f.dur;
if (life >= 1) {
f.rec.mesh.setColorAt(f.i, _white);
touched.add(f.rec.mesh);
anim.flashes.splice(i, 1);
continue;
}
var s = Math.sin(life * Math.PI);
s = s * s * f.amp;
_flash.setRGB(1 + s * f.tint[0], 1 + s * f.tint[1], 1 + s * f.tint[2]);
f.rec.mesh.setColorAt(f.i, _flash);
touched.add(f.rec.mesh);
}
touched.forEach(function (m) { if (m.instanceColor) m.instanceColor.needsUpdate = true; });
}
function stepMetal() {
if (!anim.metalTo) return;
var M = anim.metalTo, done = true;
metalMat.color.lerp(M.c, 0.085);
metalMat.roughness += (M.rough - metalMat.roughness) * 0.085;
if (Math.abs(metalMat.color.r - M.c.r) + Math.abs(metalMat.color.g - M.c.g) +
Math.abs(metalMat.color.b - M.c.b) > 0.004) done = false;
if (done) { metalMat.color.copy(M.c); metalMat.roughness = M.rough; anim.metalTo = null; }
}
function tick(now) {
requestAnimationFrame(tick);
if (!resize()) return;
var ms = now || 0;
var dt = Math.min(0.05, (ms - clock.last) / 1000 || 0.016);
clock.last = ms; clock.t += dt; clock.w = ms / 1000;
if (spin && !dragging) { swayT += dt; cam.tAz = Math.sin(swayT * 0.45) * 0.62; cam.tEl = 0.22 + Math.sin(swayT * 0.31) * 0.12; }
cam.az += (cam.tAz - cam.az) * 0.12;
cam.el += (cam.tEl - cam.el) * 0.12;
cam.dist += (cam.tDist - cam.dist) * (anim.introDone ? 0.08 : 0.035);
if (!anim.introDone && Math.abs(cam.dist - cam.tDist) < 0.6) anim.introDone = true;
root.rotation.x = Math.sin(clock.t * 0.55) * 0.045;
root.rotation.z = Math.sin(clock.t * 0.37) * 0.018;
keyLight.position.set(
26 + Math.sin(clock.t * 0.42) * 24,
42 + Math.cos(clock.t * 0.31) * 9,
58 + Math.sin(clock.t * 0.27) * 14
);
rimLight.position.set(
-44 + Math.cos(clock.t * 0.23) * 18, 14, -36 + Math.sin(clock.t * 0.29) * 16
);
stepSetting();
stepFire(dt);
stepMetal();
var ce = Math.cos(cam.el), se = Math.sin(cam.el);
camera.position.set(
Math.sin(cam.az) * ce * cam.dist,
se * cam.dist,
Math.cos(cam.az) * ce * cam.dist
);
camera.lookAt(0, 0, 0);
renderer.render(scene, camera);
}
cvs.addEventListener("pointerdown", function (e) {
dragging = true; spin = false; document.getElementById("btnSpin").setAttribute("aria-pressed", "false"); lastX = e.clientX; lastY = e.clientY;
cvs.classList.add("s-drag");
if (cvs.setPointerCapture) { try { cvs.setPointerCapture(e.pointerId); } catch (x) {} }
});
cvs.addEventListener("pointermove", function (e) {
if (!dragging) return;
cam.tAz -= (e.clientX - lastX) * 0.0085;
cam.tEl = Math.max(-0.95, Math.min(1.15, cam.tEl + (e.clientY - lastY) * 0.0065));
lastX = e.clientX; lastY = e.clientY;
});
["pointerup", "pointercancel", "pointerleave"].forEach(function (k) {
cvs.addEventListener(k, function () { dragging = false; cvs.classList.remove("s-drag"); });
});
cvs.addEventListener("wheel", function (e) {
e.preventDefault();
userZoomed = true;
cam.tDist = Math.max(30, Math.min(210, cam.tDist + e.deltaY * 0.09));
}, { passive: false });
function btn(label, meta, pressed, onClick, swatch) {
var b = document.createElement("button");
b.className = "s-opt";
b.type = "button";
b.setAttribute("aria-pressed", pressed ? "true" : "false");
if (swatch) {
var s = document.createElement("span");
s.className = "s-sw"; s.style.background = swatch;
b.appendChild(s);
}
var n = document.createElement("span");
n.className = "s-nm"; n.textContent = label;
b.appendChild(n);
if (meta) {
var m = document.createElement("span");
m.className = "s-meta"; m.textContent = meta;
b.appendChild(m);
}
b.addEventListener("click", onClick);
return b;
}
function teethTotal() { return state.arch === "both" ? state.n * 2 : state.n; }
function renderOptions() {
var S = SETTINGS[state.setting];
var o1 = document.getElementById("optSetting");
o1.textContent = "";
Object.keys(SETTINGS).forEach(function (k) {
var six = priceFor(SETTINGS[k].tiers, 6);
o1.appendChild(btn(SETTINGS[k].name, money(six) + " / 6", state.setting === k, function () {
if (state.setting === k) return;
state.setting = k; build(); renderOptions();
}));
});
document.getElementById("setBlurb").textContent = S.blurb;
var o2 = document.getElementById("optMetal");
o2.textContent = "";
Object.keys(METALS).forEach(function (k) {
o2.appendChild(btn(METALS[k].name, "", state.metal === k, function () {
if (state.metal === k) return;
state.metal = k;
anim.metalTo = { c: new THREE.Color(METALS[k].col), rough: METALS[k].rough };
renderOptions();
paintReadout(null);
}, METALS[k].sw));
});
var o3 = document.getElementById("optArch");
o3.textContent = "";
[["upper", "Top"], ["lower", "Bottom"], ["both", "Top + bottom"]].forEach(function (a) {
var b = btn(a[1], "", state.arch === a[0], function () {
if (state.arch === a[0]) return;
state.arch = a[0]; build(); renderOptions();
});
if (a[0] === "both") b.style.gridColumn = "1 / -1";
o3.appendChild(b);
});
var o4 = document.getElementById("optCount");
o4.textContent = "";
[2, 4, 6, 8, 10].forEach(function (n) {
o4.appendChild(btn(String(n), "", state.n === n, function () {
if (state.n === n) return;
state.n = n; build(); renderOptions();
}));
});
document.getElementById("countBlurb").textContent =
state.arch === "both"
? state.n + " on top and " + state.n + " on the bottom — " + teethTotal() + " teeth in all."
: state.n + " teeth, " + (state.arch === "upper" ? "top" : "bottom") + " only.";
paintQuote();
}
function paintQuote() {
var S = SETTINGS[state.setting], n = teethTotal();
var p = priceFor(S.tiers, n);
document.getElementById("qTeeth").textContent = S.name + " · " + n + " teeth";
document.getElementById("qPrice").textContent = money(p);
document.getElementById("qNote").textContent =
(S.tiers[n] != null
? "Priced at the " + n + "-tooth tier."
: "Priced between the tiers either side of " + n + " teeth.") +
" Includes the impression kit, prepaid return mailer and US shipping. Six to eight weeks from the day your impression arrives, plus shipping.";
paintCta();
}
function paintCta() {
var ok = document.getElementById("agree").checked, a = document.getElementById("cta"), u = ok ? checkoutURL() : "";
if (u) { a.href = u; a.setAttribute("aria-disabled", "false"); }
else { a.href = "#"; a.setAttribute("aria-disabled", "true"); }
document.getElementById("ctaNote").textContent = ok
? "Checkout opens with this build in the cart. Your impression kit ships right after."
: "Tick the box to unlock checkout. Your build rides along on the order, and your impression kit ships next.";
}
var lastStoneCt = 0;
function paintReadout(stones) {
if (stones != null) lastStoneCt = stones;
document.getElementById("readout").innerHTML =
"<b>" + SETTINGS[state.setting].name + "</b> · " + METALS[state.metal].name +
"<br>" + teethTotal() + " teeth · <b>" + lastStoneCt.toLocaleString("en-US") + "</b> stones set";
}
document.getElementById("btnSpin").addEventListener("click", function () {
spin = !spin; swayT = 0; this.setAttribute("aria-pressed", spin ? "true" : "false");
});
document.getElementById("btnReset").addEventListener("click", function () {
cam.tAz = 0; cam.tEl = 0.22; swayT = 0; userZoomed = false; anim.introDone = false; build(); cam.dist = cam.tDist + 50;
});
document.getElementById("btnBare").addEventListener("click", function () {
state.bare = !state.bare;
this.setAttribute("aria-pressed", state.bare ? "true" : "false");
build();
});
(function () {
var h = (location.hash || "").replace("#", "").toLowerCase();
if (SETTINGS[h]) state.setting = h;
})();
(function () {
var ol = document.getElementById("termsList");
TERMS.forEach(function (t) { var li = document.createElement("li"); li.textContent = t; ol.appendChild(li); });
document.getElementById("agree").addEventListener("change", paintCta);
document.getElementById("cta").addEventListener("click", function (e) {
if (this.getAttribute("aria-disabled") === "true") { e.preventDefault(); document.getElementById("agree").focus(); }
});
})();
init();
renderOptions();
build();
requestAnimationFrame(tick);
})();
